export const recentOrdersHeader = [
    "Id","Product Name","Date","Payment","Status","Total"
]

export const recentOrdersBody = [
    {
        id:"A8576",
        img:"01",
        product:"Nike Sports",
        delivery:"Free delivery",
        date:"Aug 15,2023",
        payment:"Paid",
        status:"Delivered",
        amount:"$44.54",
        color:"success"
    },
    {
        id:"K6556",
        img:"02",
        product:"Women Bag",
        delivery:"$83.97 delivery",
        date:"Aug 25,2023",
        payment:"Paid",
        status:"Pending",
        amount:"$51.50",
        color:"warning"
    },
    {
        id:"Y6485",
        img:"03",
        product:"Sunglasses",
        delivery:"Free delivery",
        date:"May 08,2023",
        payment:"Paid",
        status:"Cancel",
        amount:"$64.16",
        color:"danger"
    },
    {
        id:"G5653",
        img:"04",
        product:"Men T-shirt",
        delivery:"$12.55 delivery",
        date:"Feb 14,2023",
        payment:"Unpaid",
        status:"Delivered",
        amount:"$35.95",
        color:"success"
    }
]